// Auto-generated by backend/generate_audiobook.py — Audio Handbook player labels (11 languages).
export const AUDIOBOOK_UI = {
  "title": {
    "id": "Buku Audio Manasik",
    "en": "Audio Book of Manasik",
    "ar": "كتاب صوتي للمناسك",
    "fr": "Livre Audio des Manasik",
    "de": "Audiobuch der Manasik",
    "es": "Libro de Audio de Manasik",
    "ru": "Аудиокнига Манасик",
    "zh": "朝觐功课有声书",
    "ja": "マナーシク音声ブック",
    "ko": "마나시크 오디오북",
    "hi": "मनासिक ऑडियो बुक"
  },
  "listenBtn": {
    "id": "Dengarkan Buku Panduan",
    "en": "Listen to the Guide Book",
    "ar": "استمع إلى كتاب الدليل",
    "fr": "Écouter le Livre Guide",
    "de": "Führungsbuch anhören",
    "es": "Escuchar el Libro Guía",
    "ru": "Слушать книгу-руководство",
    "zh": "收听指南书",
    "ja": "ガイドブックを聴く",
    "ko": "안내서 듣기",
    "hi": "गाइड बुक सुनें"
  },
  "resumeBtn": {
    "id": "Lanjutkan dari Bab {n}",
    "en": "Continue from Chapter {n}",
    "ar": "متابعة من الفصل {n}",
    "fr": "Reprendre depuis le Chapitre {n}",
    "de": "Weiter ab Kapitel {n}",
    "es": "Continuar desde el Capítulo {n}",
    "ru": "Продолжить с главы {n}",
    "zh": "从第 {n} 章继续",
    "ja": "第 {n} 章から続ける",
    "ko": "{n}장에서 계속하기",
    "hi": "अध्याय {n} से जारी रखें"
  },
  "chapterOf": {
    "id": "Bab {n} dari {total}",
    "en": "Chapter {n} of {total}",
    "ar": "الفصل {n} من {total}",
    "fr": "Chapitre {n} sur {total}",
    "de": "Kapitel {n} von {total}",
    "es": "Capítulo {n} de {total}",
    "ru": "Глава {n} из {total}",
    "zh": "第 {n} 章，共 {total} 章",
    "ja": "第 {n} 章（全 {total} 章）",
    "ko": "{total}장 중 {n}장",
    "hi": "अध्याय {n} / {total}"
  },
  "nowReading": {
    "id": "Sedang dibacakan",
    "en": "Now being read",
    "ar": "يُقرأ الآن",
    "fr": "En cours de lecture",
    "de": "Wird gerade vorgelesen",
    "es": "Siendo leído ahora",
    "ru": "Сейчас читается",
    "zh": "正在朗读",
    "ja": "現在読み上げ中",
    "ko": "현재 읽는 중",
    "hi": "अभी पढ़ा जा रहा है"
  },
  "loading": {
    "id": "Menyiapkan suara…",
    "en": "Preparing audio…",
    "ar": "جارٍ تحضير الصوت…",
    "fr": "Préparation du son…",
    "de": "Audio wird vorbereitet…",
    "es": "Preparando el audio…",
    "ru": "Подготовка аудио…",
    "zh": "正在准备音频…",
    "ja": "音声を準備中…",
    "ko": "오디오 준비 중…",
    "hi": "ऑडियो तैयार हो रही है…"
  },
  "paused": {
    "id": "Dijeda",
    "en": "Paused",
    "ar": "متوقف مؤقتاً",
    "fr": "En pause",
    "de": "Pausiert",
    "es": "En pausa",
    "ru": "На паузе",
    "zh": "已暂停",
    "ja": "一時停止中",
    "ko": "일시정지됨",
    "hi": "रुका हुआ"
  },
  "play": {
    "id": "Putar",
    "en": "Play",
    "ar": "تشغيل",
    "fr": "Lire",
    "de": "Abspielen",
    "es": "Reproducir",
    "ru": "Воспроизвести",
    "zh": "播放",
    "ja": "再生",
    "ko": "재생",
    "hi": "चलाएं"
  },
  "pause": {
    "id": "Jeda",
    "en": "Pause",
    "ar": "إيقاف مؤقت",
    "fr": "Pause",
    "de": "Pause",
    "es": "Pausar",
    "ru": "Пауза",
    "zh": "暂停",
    "ja": "一時停止",
    "ko": "일시정지",
    "hi": "रोकें"
  },
  "prev": {
    "id": "Bab sebelumnya",
    "en": "Previous Chapter",
    "ar": "الفصل السابق",
    "fr": "Chapitre précédent",
    "de": "Vorheriges Kapitel",
    "es": "Capítulo anterior",
    "ru": "Предыдущая глава",
    "zh": "上一章",
    "ja": "前の章",
    "ko": "이전 장",
    "hi": "पिछला अध्याय"
  },
  "next": {
    "id": "Bab berikutnya",
    "en": "Next Chapter",
    "ar": "الفصل التالي",
    "fr": "Chapitre suivant",
    "de": "Nächstes Kapitel",
    "es": "Capítulo siguiente",
    "ru": "Следующая глава",
    "zh": "下一章",
    "ja": "次の章",
    "ko": "다음 장",
    "hi": "अगला अध्याय"
  },
  "chapters": {
    "id": "Daftar Bab",
    "en": "Chapter List",
    "ar": "قائمة الفصول",
    "fr": "Liste des chapitres",
    "de": "Kapitelliste",
    "es": "Lista de capítulos",
    "ru": "Список глав",
    "zh": "章节列表",
    "ja": "章一覧",
    "ko": "장 목록",
    "hi": "अध्याय सूची"
  },
  "close": {
    "id": "Tutup",
    "en": "Close",
    "ar": "إغلاق",
    "fr": "Fermer",
    "de": "Schließen",
    "es": "Cerrar",
    "ru": "Закрыть",
    "zh": "关闭",
    "ja": "閉じる",
    "ko": "닫기",
    "hi": "बंद करें"
  },
  "finished": {
    "id": "Selesai — seluruh buku panduan telah dibacakan.",
    "en": "Finished — the entire guide has been read aloud.",
    "ar": "اكتمل — تمت قراءة الدليل بالكامل.",
    "fr": "Terminé — l'intégralité du guide a été lue.",
    "de": "Fertig — das gesamte Handbuch wurde vorgelesen.",
    "es": "Finalizado — se ha leído todo el manual en voz alta.",
    "ru": "Завершено — весь справочник был прочитан вслух.",
    "zh": "完成 — 整本指南已全部朗读完毕。",
    "ja": "完了 — ガイド全体の読み上げが終わりました。",
    "ko": "완료 — 전체 안내서를 모두 읽었습니다.",
    "hi": "समाप्त — संपूर्ण गाइड पढ़ी जा चुकी है।"
  },
  "restart": {
    "id": "Putar dari awal",
    "en": "Play from the beginning",
    "ar": "تشغيل من البداية",
    "fr": "Lire depuis le début",
    "de": "Von Anfang an abspielen",
    "es": "Reproducir desde el principio",
    "ru": "Воспроизвести с начала",
    "zh": "从头播放",
    "ja": "最初から再生する",
    "ko": "처음부터 재생",
    "hi": "शुरू से चलाएं"
  },
  "quotaHit": {
    "id": "Kuota pembuatan suara harian telah habis. Posisi Anda tersimpan — lanjutkan besok.",
    "en": "Daily voice generation quota has been reached. Your position is saved — continue tomorrow.",
    "ar": "تم استنفاد حصة توليد الصوت اليومية. تم حفظ موضعك — تابع غداً.",
    "fr": "Le quota quotidien de génération vocale est atteint. Votre position est sauvegardée — continuez demain.",
    "de": "Das tägliche Kontingent für die Sprachgenerierung ist ausgeschöpft. Ihre Position wurde gespeichert — fahren Sie morgen fort.",
    "es": "Se ha alcanzado la cuota diaria de generación de voz. Su posición está guardada — continúe mañana.",
    "ru": "Дневная квота генерации голоса исчерпана. Ваша позиция сохранена — продолжите завтра.",
    "zh": "每日语音生成配额已用尽。您的进度已保存 — 明天继续。",
    "ja": "1日の音声生成クォータに達しました。進行状況は保存されています — 明日続きをどうぞ。",
    "ko": "일일 음성 생성 할당량이 소진되었습니다. 위치가 저장되었습니다 — 내일 계속하세요.",
    "hi": "दैनिक वॉइस जनरेशन कोटा समाप्त हो गया है। आपकी स्थिति सहेजी गई है — कल जारी रखें।"
  },
  "error": {
    "id": "Audio tidak tersedia saat ini. Ketuk Putar untuk mencoba lagi.",
    "en": "Audio is currently unavailable. Tap Play to try again.",
    "ar": "الصوت غير متاح حالياً. اضغط على تشغيل للمحاولة مرة أخرى.",
    "fr": "L'audio est actuellement indisponible. Appuyez sur Lecture pour réessayer.",
    "de": "Audio ist derzeit nicht verfügbar. Tippen Sie auf Abspielen, um es erneut zu versuchen.",
    "es": "El audio no está disponible en este momento. Toque Reproducir para intentarlo de nuevo.",
    "ru": "Аудио в данный момент недоступно. Нажмите «Воспроизвести», чтобы повторить попытку.",
    "zh": "音频暂时不可用。点击播放以重试。",
    "ja": "現在オーディオを利用できません。再生をタップして再試行してください。",
    "ko": "현재 오디오를 사용할 수 없습니다. 재생을 탭하여 다시 시도하세요.",
    "hi": "ऑडियो अभी उपलब्ध नहीं है। पुनः प्रयास करने के लिए प्ले टैप करें।"
  },
  "hajjPart": {
    "id": "Rangkaian Haji",
    "en": "Hajj Series",
    "ar": "سلسلة الحج",
    "fr": "Série du Hajj",
    "de": "Hajj-Reihe",
    "es": "Serie del Hajj",
    "ru": "Серия о Хадже",
    "zh": "朝觐系列",
    "ja": "ハッジ・シリーズ",
    "ko": "하지 시리즈",
    "hi": "हज श्रृंखला"
  },
  "speed": {
    "id": "Kecepatan putar",
    "en": "Playback Speed",
    "ar": "سرعة التشغيل",
    "fr": "Vitesse de lecture",
    "de": "Wiedergabegeschwindigkeit",
    "es": "Velocidad de reproducción",
    "ru": "Скорость воспроизведения",
    "zh": "播放速度",
    "ja": "再生速度",
    "ko": "재생 속도",
    "hi": "प्लेबैक गति"
  },
  "sleepTimer": {
    "id": "Timer tidur",
    "en": "Sleep Timer",
    "ar": "مؤقت النوم",
    "fr": "Minuterie de sommeil",
    "de": "Schlaf-Timer",
    "es": "Temporizador de reposo",
    "ru": "Таймер сна",
    "zh": "睡眠定时器",
    "ja": "スリープタイマー",
    "ko": "수면 타이머",
    "hi": "स्लीप टाइमर"
  },
  "sleepOff": {
    "id": "Matikan timer",
    "en": "Turn Off Timer",
    "ar": "إيقاف المؤقت",
    "fr": "Désactiver la minuterie",
    "de": "Timer ausschalten",
    "es": "Apagar temporizador",
    "ru": "Выключить таймер",
    "zh": "关闭定时器",
    "ja": "タイマーをオフにする",
    "ko": "타이머 끄기",
    "hi": "टाइमर बंद करें"
  },
  "sleepEndChapter": {
    "id": "Akhir bab ini",
    "en": "End of This Chapter",
    "ar": "نهاية هذا الفصل",
    "fr": "Fin de ce chapitre",
    "de": "Ende dieses Kapitels",
    "es": "Fin de este capítulo",
    "ru": "Конец этой главы",
    "zh": "本章结束",
    "ja": "この章の終わり",
    "ko": "이 챕터 끝",
    "hi": "इस अध्याय का अंत"
  },
  "minutes": {
    "id": "{n} menit",
    "en": "{n} minutes",
    "ar": "{n} دقيقة",
    "fr": "{n} minutes",
    "de": "{n} Minuten",
    "es": "{n} minutos",
    "ru": "{n} минут",
    "zh": "{n} 分钟",
    "ja": "{n} 分",
    "ko": "{n} 분",
    "hi": "{n} मिनट"
  },
  "sleepActive": {
    "id": "Timer tidur: {t}",
    "en": "Sleep Timer: {t}",
    "ar": "مؤقت النوم: {t}",
    "fr": "Minuterie de sommeil : {t}",
    "de": "Schlaf-Timer: {t}",
    "es": "Temporizador de reposo: {t}",
    "ru": "Таймер сна: {t}",
    "zh": "睡眠定时器：{t}",
    "ja": "スリープタイマー：{t}",
    "ko": "수면 타이머: {t}",
    "hi": "स्लीप टाइमर: {t}"
  },
  "sleepChapterActive": {
    "id": "Berhenti di akhir bab ini",
    "en": "Stop at the end of this chapter",
    "ar": "التوقف عند نهاية هذا الفصل",
    "fr": "S'arrêter à la fin de ce chapitre",
    "de": "Am Ende dieses Kapitels anhalten",
    "es": "Detener al final de este capítulo",
    "ru": "Остановиться в конце этой главы",
    "zh": "在本章结束时停止",
    "ja": "この章の終わりで停止する",
    "ko": "이 챕터가 끝날 때 정지",
    "hi": "इस अध्याय के अंत में रोकें"
  },
  "sleepDone": {
    "id": "Timer tidur selesai — pemutaran dijeda.",
    "en": "Sleep timer finished — playback paused.",
    "ar": "انتهى مؤقت النوم — تم إيقاف التشغيل مؤقتًا.",
    "fr": "Minuterie de sommeil terminée — lecture mise en pause.",
    "de": "Schlaf-Timer beendet — Wiedergabe pausiert.",
    "es": "Temporizador de sueño finalizado — reproducción en pausa.",
    "ru": "Таймер сна завершён — воспроизведение приостановлено.",
    "zh": "睡眠定时器结束——播放已暂停。",
    "ja": "スリープタイマーが終了しました — 再生が一時停止されました。",
    "ko": "수면 타이머 종료 — 재생이 일시 정지되었습니다.",
    "hi": "स्लीप टाइमर समाप्त — प्लेबैक रोक दिया गया।"
  },
  "downloadPack": {
    "id": "Unduh untuk offline",
    "en": "Download for offline",
    "ar": "تنزيل للاستخدام دون اتصال",
    "fr": "Télécharger pour une utilisation hors ligne",
    "de": "Für die Offline-Nutzung herunterladen",
    "es": "Descargar para uso sin conexión",
    "ru": "Скачать для офлайн-использования",
    "zh": "下载以供离线使用",
    "ja": "オフライン用にダウンロード",
    "ko": "오프라인용으로 다운로드",
    "hi": "ऑफ़लाइन के लिए डाउनलोड करें"
  },
  "downloading": {
    "id": "Mengunduh {done}/{total}…",
    "en": "Downloading {done}/{total}…",
    "ar": "جارٍ التنزيل {done}/{total}…",
    "fr": "Téléchargement {done}/{total}…",
    "de": "Wird heruntergeladen {done}/{total}…",
    "es": "Descargando {done}/{total}…",
    "ru": "Загрузка {done}/{total}…",
    "zh": "正在下载 {done}/{total}…",
    "ja": "ダウンロード中 {done}/{total}…",
    "ko": "다운로드 중 {done}/{total}…",
    "hi": "डाउनलोड हो रहा है {done}/{total}…"
  },
  "downloaded": {
    "id": "Tersimpan offline",
    "en": "Saved offline",
    "ar": "محفوظ للاستخدام دون اتصال",
    "fr": "Enregistré hors ligne",
    "de": "Offline gespeichert",
    "es": "Guardado sin conexión",
    "ru": "Сохранено для офлайна",
    "zh": "已离线保存",
    "ja": "オフラインで保存済み",
    "ko": "오프라인으로 저장됨",
    "hi": "ऑफ़लाइन सहेजा गया"
  },
  "downloadCancel": {
    "id": "Batalkan unduhan",
    "en": "Cancel download",
    "ar": "إلغاء التنزيل",
    "fr": "Annuler le téléchargement",
    "de": "Download abbrechen",
    "es": "Cancelar descarga",
    "ru": "Отменить загрузку",
    "zh": "取消下载",
    "ja": "ダウンロードをキャンセル",
    "ko": "다운로드 취소",
    "hi": "डाउनलोड रद्द करें"
  },
  "downloadDelete": {
    "id": "Hapus paket offline",
    "en": "Delete offline package",
    "ar": "حذف الحزمة غير المتصلة",
    "fr": "Supprimer le package hors ligne",
    "de": "Offline-Paket löschen",
    "es": "Eliminar paquete sin conexión",
    "ru": "Удалить офлайн-пакет",
    "zh": "删除离线包",
    "ja": "オフラインパッケージを削除",
    "ko": "오프라인 패키지 삭제",
    "hi": "ऑफ़लाइन पैकेज हटाएं"
  },
  "downloadHint": {
    "id": "Seluruh buku audio dalam bahasa ini (± {mb} MB) disimpan di perangkat agar bisa didengarkan tanpa internet di Tanah Suci.",
    "en": "All audio books in this language (± {mb} MB) are stored on the device so you can listen without internet in the Holy Land.",
    "ar": "جميع الكتب الصوتية بهذه اللغة (± {mb} ميغابايت) محفوظة على الجهاز حتى تتمكن من الاستماع بدون إنترنت في الأراضي المقدسة.",
    "fr": "Tous les livres audio dans cette langue (± {mb} Mo) sont enregistrés sur l'appareil pour vous permettre d'écouter sans internet en Terre Sainte.",
    "de": "Alle Hörbücher in dieser Sprache (± {mb} MB) werden auf dem Gerät gespeichert, damit Sie im Heiligen Land ohne Internet hören können.",
    "es": "Todos los audiolibros en este idioma (± {mb} MB) se almacenan en el dispositivo para que pueda escucharlos sin internet en Tierra Santa.",
    "ru": "Все аудиокниги на этом языке (± {mb} МБ) сохранены на устройстве, чтобы вы могли слушать без интернета на Святой земле.",
    "zh": "该语言的所有有声书（± {mb} MB）已存储在设备上，以便您在圣地无需网络即可收听。",
    "ja": "この言語のすべてのオーディオブック（± {mb} MB）はデバイスに保存されており、聖地でインターネットなしでお聴きいただけます。",
    "ko": "이 언어의 모든 오디오북(± {mb} MB)이 기기에 저장되어 성지에서 인터넷 없이 들을 수 있습니다.",
    "hi": "इस भाषा की सभी ऑडियो पुस्तकें (± {mb} MB) डिवाइस पर सहेजी गई हैं ताकि आप पवित्र भूमि में बिना इंटरनेट के सुन सकें।"
  },
  "downloadsTitle": {
    "id": "Buku Audio Manasik (Offline)",
    "en": "Manasik Audio Books (Offline)",
    "ar": "الكتب الصوتية للمناسك (بدون إنترنت)",
    "fr": "Livres Audio Manasik (Hors ligne)",
    "de": "Manasik-Hörbücher (Offline)",
    "es": "Audiolibros de Manasik (Sin conexión)",
    "ru": "Аудиокниги Манасик (Офлайн)",
    "zh": "朝觐礼仪有声书（离线）",
    "ja": "マナーシク・オーディオブック（オフライン）",
    "ko": "마나식 오디오북 (오프라인)",
    "hi": "मनासिक ऑडियो पुस्तकें (ऑफ़लाइन)"
  },
  "downloadPartial": {
    "id": "Sebagian tersimpan ({done}/{total}) — lanjutkan unduhan",
    "en": "Partially saved ({done}/{total}) — resume download",
    "ar": "محفوظ جزئياً ({done}/{total}) — استئناف التنزيل",
    "fr": "Partiellement enregistré ({done}/{total}) — reprendre le téléchargement",
    "de": "Teilweise gespeichert ({done}/{total}) — Download fortsetzen",
    "es": "Guardado parcialmente ({done}/{total}) — reanudar la descarga",
    "ru": "Частично сохранено ({done}/{total}) — продолжить загрузку",
    "zh": "部分已保存（{done}/{total}）— 继续下载",
    "ja": "一部保存済み（{done}/{total}）— ダウンロードを再開",
    "ko": "일부 저장됨 ({done}/{total}) — 다운로드 재개",
    "hi": "आंशिक रूप से सहेजा गया ({done}/{total}) — डाउनलोड जारी रखें"
  },
  "downloadQuota": {
    "id": "Kuota suara harian habis — unduhan dihentikan, lanjutkan besok.",
    "en": "Daily audio quota exhausted — download stopped, resume tomorrow.",
    "ar": "انتهى الحصة الصوتية اليومية — تم إيقاف التنزيل، استأنف غداً.",
    "fr": "Quota audio quotidien épuisé — téléchargement arrêté, reprenez demain.",
    "de": "Tägliches Audio-Kontingent erschöpft — Download gestoppt, morgen fortsetzen.",
    "es": "Cuota de audio diaria agotada — descarga detenida, reanude mañana.",
    "ru": "Дневная квота аудио исчерпана — загрузка остановлена, продолжите завтра.",
    "zh": "每日音频配额已用尽——下载已停止，请明天继续。",
    "ja": "1日のオーディオ容量上限に達しました — ダウンロードを停止しました。明日再開してください。",
    "ko": "일일 오디오 할당량 소진 — 다운로드가 중단되었습니다. 내일 재개하세요.",
    "hi": "दैनिक ऑडियो कोटा समाप्त — डाउनलोड रोका गया, कल जारी रखें।"
  },
  "downloadError": {
    "id": "Unduhan gagal. Coba lagi.",
    "en": "Download failed. Please try again.",
    "ar": "فشل التنزيل. حاول مرة أخرى.",
    "fr": "Échec du téléchargement. Veuillez réessayer.",
    "de": "Download fehlgeschlagen. Bitte versuche es erneut.",
    "es": "Error en la descarga. Inténtelo de nuevo.",
    "ru": "Ошибка загрузки. Попробуйте ещё раз.",
    "zh": "下载失败，请重试。",
    "ja": "ダウンロードに失敗しました。もう一度お試しください。",
    "ko": "다운로드에 실패했습니다. 다시 시도해 주세요.",
    "hi": "डाउनलोड विफल हुआ। कृपया पुनः प्रयास करें।"
  },
  "downloadStale": {
    "id": "Konten telah diperbarui — unduh ulang paket ini.",
    "en": "Content has been updated — please re-download this package.",
    "ar": "تم تحديث المحتوى — يرجى إعادة تنزيل هذه الحزمة.",
    "fr": "Le contenu a été mis à jour — veuillez re-télécharger ce pack.",
    "de": "Der Inhalt wurde aktualisiert — bitte dieses Paket erneut herunterladen.",
    "es": "El contenido ha sido actualizado — por favor, vuelve a descargar este paquete.",
    "ru": "Содержимое было обновлено — пожалуйста, загрузите этот пакет заново.",
    "zh": "内容已更新——请重新下载此包。",
    "ja": "コンテンツが更新されました — このパッケージを再ダウンロードしてください。",
    "ko": "콘텐츠가 업데이트되었습니다 — 이 패키지를 다시 다운로드하세요.",
    "hi": "सामग्री अपडेट हो गई है — कृपया इस पैकेज को फिर से डाउनलोड करें।"
  },
  "offlineBadge": {
    "id": "Offline",
    "en": "Offline",
    "ar": "غير متصل",
    "fr": "Hors ligne",
    "de": "Offline",
    "es": "Sin conexión",
    "ru": "Офлайн",
    "zh": "离线",
    "ja": "オフライン",
    "ko": "오프라인",
    "hi": "ऑफ़लाइन"
  },
  "segments": {
    "id": "{n} potongan audio",
    "en": "{n} audio segments",
    "ar": "{n} مقطع صوتي",
    "fr": "{n} segments audio",
    "de": "{n} Audiosegmente",
    "es": "{n} segmentos de audio",
    "ru": "{n} аудиосегментов",
    "zh": "{n} 个音频片段",
    "ja": "{n} 個のオーディオセグメント",
    "ko": "{n}개의 오디오 세그먼트",
    "hi": "{n} ऑडियो खंड"
  },
  "listen": {
    "id": "Dengarkan",
    "en": "Listen",
    "ar": "استمع",
    "fr": "Écouter",
    "de": "Anhören",
    "es": "Escuchar",
    "ru": "Слушать",
    "zh": "聆听",
    "ja": "聴く",
    "ko": "듣기",
    "hi": "सुनें"
  },
  "listenDay": {
    "id": "Dengarkan bab hari ini",
    "en": "Listen to today's chapter",
    "ar": "استمع إلى فصل اليوم",
    "fr": "Écouter le chapitre du jour",
    "de": "Heutiges Kapitel anhören",
    "es": "Escuchar el capítulo de hoy",
    "ru": "Слушать главу дня",
    "zh": "聆听今日章节",
    "ja": "今日の章を聴く",
    "ko": "오늘의 장 듣기",
    "hi": "आज का अध्याय सुनें"
  },
  "eta": {
    "id": "±{t} tersisa",
    "en": "±{t} remaining",
    "ar": "±{t} متبقية",
    "fr": "±{t} restant",
    "de": "±{t} verbleibend",
    "es": "±{t} restante",
    "ru": "±{t} осталось",
    "zh": "剩余 ±{t}",
    "ja": "残り ±{t}",
    "ko": "±{t} 남음",
    "hi": "±{t} शेष"
  },
  "minutesShort": {
    "id": "{n} mnt",
    "en": "{n} min",
    "ar": "{n} د",
    "fr": "{n} min",
    "de": "{n} Min.",
    "es": "{n} min",
    "ru": "{n} мин",
    "zh": "{n} 分",
    "ja": "{n} 分",
    "ko": "{n} 분",
    "hi": "{n} मि."
  },
  "secondsShort": {
    "id": "{n} dtk",
    "en": "{n} sec",
    "ar": "{n} ث",
    "fr": "{n} sec",
    "de": "{n} Sek.",
    "es": "{n} seg",
    "ru": "{n} сек",
    "zh": "{n} 秒",
    "ja": "{n} 秒",
    "ko": "{n} 초",
    "hi": "{n} से."
  },
  "waitingNet": {
    "id": "Koneksi terputus — unduhan lanjut otomatis saat online kembali",
    "en": "Connection lost — download will resume automatically when back online",
    "ar": "انقطع الاتصال — سيستأنف التنزيل تلقائيًا عند استعادة الاتصال",
    "fr": "Connexion perdue — le téléchargement reprendra automatiquement dès le retour en ligne",
    "de": "Verbindung unterbrochen — Download wird automatisch fortgesetzt, sobald die Verbindung wiederhergestellt ist",
    "es": "Conexión perdida — la descarga se reanudará automáticamente al recuperar la conexión",
    "ru": "Соединение прервано — загрузка возобновится автоматически при восстановлении сети",
    "zh": "连接已断开 — 恢复网络后将自动继续下载",
    "ja": "接続が切断されました — オンラインに戻ると自動的にダウンロードを再開します",
    "ko": "연결이 끊겼습니다 — 온라인 상태로 돌아오면 자동으로 다운로드가 재개됩니다",
    "hi": "कनेक्शन टूट गया — ऑनलाइन होने पर डाउनलोड स्वतः फिर से शुरू होगा"
  },
  "resumedNet": {
    "id": "Koneksi kembali — unduhan dilanjutkan",
    "en": "Connection restored — download resumed",
    "ar": "استُعيد الاتصال — استُؤنف التنزيل",
    "fr": "Connexion rétablie — téléchargement repris",
    "de": "Verbindung wiederhergestellt — Download fortgesetzt",
    "es": "Conexión restablecida — descarga reanudada",
    "ru": "Соединение восстановлено — загрузка возобновлена",
    "zh": "连接已恢复 — 下载已继续",
    "ja": "接続が回復しました — ダウンロードを再開しました",
    "ko": "연결이 복구되었습니다 — 다운로드가 재개되었습니다",
    "hi": "कनेक्शन बहाल हुआ — डाउनलोड फिर से शुरू हुआ"
  }
};
